// export const baseUrl = "https://api.onebyone.ng/api/v1";
export const baseUrl = "https://test-api.onebyone.ng/api/v1";

export const getToken = () => localStorage.getItem("authToken");
